import React from "react";
import {
  FaExchangeAlt,
  FaRobot,
  FaVial,
  FaCoins,
  FaShieldAlt,
  FaDesktop,
  FaBell,
} from "react-icons/fa";

function Backtesting() {
  return (
    <>
      <div className="services-style-five-area default-padding bottom-less">
        <div className="container">
          <div className="left-heading">
            <div className="row">
              <div className="col-lg-8 offset-lg-2">
                <h4 className="sub-title">Xeer Features</h4>
                <div className="right">
                  <h2 className="title">
                    Key Features of Our Crypto Trading Bots
                  </h2>
                  {/* <p>
                  Xeer Technology provides comprehensive development services
                  for projects seeking to harness the benefits of Binance Smart
                  Chain. Our experienced blockchain developers specialize in
                  designing custom solutions tailored to your specific business
                  goals.
                </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="services-style-five-items">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaExchangeAlt size={48} color="#0a1f44" />
                  </div>
                  <h4>Multi-Exchange Integration</h4>
                  <p>
                    Trade across multiple exchanges simultaneously, such as
                    Binance, Coinbase, and Kraken, to capture opportunities
                    across diverse markets and pairs.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaRobot size={48} color="#0a1f44" />
                  </div>
                  <h4>24/7 Automated Trading</h4>
                  <p>
                    Our bots operate round-the-clock, allowing you to benefit
                    from market movements any time of the day, even while you
                    sleep.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaVial size={48} color="#0a1f44" />
                  </div>
                  <h4>Backtesting and Simulation Tools</h4>
                  <p>
                    Test your strategies against historical data to optimize
                    performance and refine parameters before live trading,
                    minimizing risk.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaCoins size={48} color="#0a1f44" />
                  </div>
                  <h4>BSC Token Development (BEP-20)</h4>
                  <p>
                    Launch your own BEP-20 tokens on BSC, fully customized to
                    your project’s needs with features like token staking,
                    liquidity pools, and burn mechanisms.
                  </p>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaShieldAlt size={48} color="#0a1f44" />
                  </div>
                  <h4>Risk Management & Stop-Loss Features</h4>
                  <p>
                    Configure custom risk parameters, including stop-loss,
                    take-profit, and position sizing, to protect your capital
                    and enhance long-term profitability.
                  </p>
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 mb-30 service-five-single">
                <div className="service-style-five-item">
                  <div className="pb-4 d-flex align-items-center">
                    <FaDesktop size={48} color="#0a1f44" />
                  </div>
                  <h4>User-Friendly Interface</h4>
                  <p>
                    An intuitive dashboard enables traders to set up, monitor,
                    and adjust bot settings in real-time, simplifying the
                    trading experience for all users.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Backtesting;
